<script>
import ContactMultiselectDropdown from 'dashboard/routes/dashboard/wgptBoards/components/ContactMultiselectDropdown.vue';
import ContactAvatar from './ContactAvatar.vue';

import ButtonNext from 'dashboard/components-next/button/Button.vue';
import Dropdown from 'dashboard/components-next/wgpt/Dropdown/Dropdown.vue';

export default {
  components: {
    ContactMultiselectDropdown,
    Dropdown,
    ContactAvatar,
    ButtonNext,
  },
  props: {
    contactIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update'],
  data() {
    return {
      showSearchDropdown: false,
      notFoundContactIds: [],
      selectedContact: {},
    };
  },
  methods: {
    async onUpdate(selectedItems) {
      this.$emit('update', selectedItems);
    },
    addItem({ id }) {
      const result = this.contactIds.concat(id);
      this.onUpdate(result);
    },
    removeItem({ id }, toggle) {
      const result = this.contactIds.filter(
        selectedContact => selectedContact !== id
      );
      this.onUpdate(result);

      if (result.length > 0) return;
      toggle();
    },
    onContactNotFound(contactId) {
      if (this.notFoundContactIds.includes(contactId)) return;
      this.notFoundContactIds.push(contactId);
    },
    onContactFound(contactId) {
      if (!this.notFoundContactIds.includes(contactId)) return;
      this.notFoundContactIds = this.notFoundContactIds.filter(
        notFoundContactId => notFoundContactId !== contactId
      );
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div>
    <label>
      {{ $t('WGPT_CAMPAIGNS.TEST.FORM.CONTACTS.LABEL') }}
    </label>

    <div class="flex gap-1 overflow-hidden flex-wrap">
      <div v-for="contactId in contactIds" :key="contactId">
        <ContactAvatar
          :contact-id="contactId"
          @found="onContactFound(contactId)"
          @not-found="onContactNotFound(contactId)"
        />
      </div>

      <Dropdown>
        <template #trigger="{ toggle }">
          <ButtonNext
            size="sm"
            color="slate"
            variant="faded"
            icon="i-lucide-plus"
            class="!rounded-xl"
            @click="toggle"
          />
        </template>
        <template #default="{ toggle }">
          <ContactMultiselectDropdown
            :selected-ids="contactIds"
            @add="addItem"
            @remove="e => removeItem(e, toggle)"
            @close="toggle"
          />
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.contact-dropdown ::v-deep {
  .dropdown-pane {
    @apply w-44;
  }
}

.contact-info-popup ::v-deep {
  .dropdown-pane {
    @apply w-80 p-4;
  }
}
</style>
